module.exports = __webpack_public_path__ + "img/icon-gold30.24f509a3.png";